<template>
  <div class="md-layout">
    <resource-table
        :columns="columns"
        :fetch-data="fetchLevels"
    >

      <!-- Actions Slot -->
      <template #actions="{ item }">
        <md-button
            class="md-icon-button md-raised md-round md-info"
            @click="goToView(item.id)"
        >
          <md-icon>edit</md-icon>
        </md-button>
      </template>
    </resource-table>
  </div>
</template>

<script>
import ResourceTable from "@/pages/Biotime/ResourceTable.vue";

export default {
  components: {ResourceTable},

  data() {
    return {
      columns: [
        {field: 'emp_code', label: 'Labourer Code'},
        {field: 'state', label: 'State'},
        {field: 'time', label: 'Time', type: 'date'},
        {field: 'device', label: 'Device'},
        {field: 'ext_id', label: 'External ID'}
      ],
    };
  },

  methods: {
    // Fetch Levels Data from Vuex
    async fetchLevels(params) {
      try {
        await this.$store.dispatch('biotimeAttendances/list', params);
        return {
          data: this.$store.getters['biotimeAttendances/list'],
          total: this.$store.getters['biotimeAttendances/listTotal'],
        };
      } catch (e) {
        this.$store.dispatch('alerts/error', 'Failed to fetch biotime Attendances');
        return {data: [], total: 0};
      }
    },

    goToView(id) {
      this.$router.push({name: 'Biotime Attendance View', params: {id}});
    }
  },
};
</script>

<style scoped>
.md-layout {
  padding: 1rem;
}
</style>